module.exports = __webpack_public_path__ + "img/wx.1b4ec85f.png";